import { createAction } from 'redux-act';

export const setPanelPendingAction = createAction('Set a pending action flag of a panel', (panelId, pendingActionName, pendingActionValue) => ({panelId, pendingActionName, pendingActionValue}));
